import React, { FC, useContext, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Drawer, Input, InputRef } from 'antd';
import { AiOutlineClose } from 'react-icons/ai';
import { SearchContext } from 'app/contexts/SearchContext';
import './SearchBar.scss';
const { Search } = Input;

const SearchBar: FC = () => {
  const { isSearchBar, closeSearchBar, setSearchValue } =
    useContext(SearchContext);
  const inputRef = useRef<InputRef>(null);
  let history = useHistory();

  const hangleOnSubmit = () => {
    history.push('/search');
    closeSearchBar();
  };

  const setFocus = (isOpen: boolean) => {
    isOpen && inputRef.current?.focus();
  };

  const suffix = (
    <AiOutlineClose
      onClick={closeSearchBar}
      style={{
        fontSize: 25,
        color: '#fff',
        cursor: 'pointer',
      }}
    />
  );
  return (
    <Drawer
      className="search-bar"
      placement={'top'}
      closable={false}
      onClose={closeSearchBar}
      visible={isSearchBar}
      key={'top'}
      maskStyle={{
        backgroundColor: 'rgba(11, 31, 58,.85)',
      }}
      afterVisibleChange={setFocus}
    >
      <Search
        placeholder="ENTER A TICKER / FUND, KEYWORD OR PHRASE"
        size="large"
        enterButton={suffix}
        onChange={e => setSearchValue(e.target.value)}
        onPressEnter={hangleOnSubmit}
        autoFocus
        ref={inputRef}
      />
    </Drawer>
  );
};

export default SearchBar;
